export const domainInfo = {
  DECODING: { abbr: "D", color: "var(--decoding)", name: "Decoding" },
  PHONEMIC_AWARENESS: {
    abbr: "PA",
    color: "var(--phonological-awareness)",
    name: "Phonological Awareness",
  },
  PHONOLOGICAL_AWARENESS: {
    abbr: "PA",
    color: "var(--phonological-awareness)",
    name: "Phonological Awareness",
  },
  SIGHT_RECOGNITION: {
    abbr: "SR",
    color: "var(--sight-recognition)",
    name: "High Frequency Words",
  },
  WORLD_KNOWLEDGE: {
    abbr: "BK",
    color: "var(--background-knowledge)",
    name: "Background Knowledge",
  },
  VOCABULARY: { abbr: "V", color: "var(--vocabulary)", name: "Vocabulary" },
  STRUCTURE_REASONING: {
    abbr: "SR",
    color: "var(--structures-reasoning)",
    name: "Structures & Reasoning",
  },
};
